import React, { useRef, useState } from "react"
import emailjs from "@emailjs/browser"
import contact1 from "./contact1.png"
import "./Contact.css"
import {RiFacebookBoxLine, RiLinkedinBoxLine, RiGithubFill} from "react-icons/ri"
import { GrSend } from "react-icons/gr"

const Contact = () => {
  const form  = useRef();
  const [data, setData] = useState({
    fullname: "",
    phone: "",
    email: "",
    subject: "",
    message: "",})

  const InputEvent = (event) => {
    const { name, value } = event.target

    setData((preVal) => {
      return {
        ...preVal,
        [name]: value,
      }
    })
  }

  const formSubmit = (event) => {
    event.preventDefault()

    alert(
      `My name is ${data.fullname}. 
	My phone number is ${data.phone}. 
	My email address is ${data.email}. 
	My Subject on  ${data.subject}. 
	Here is my message I want to say : ${data.message}. 
	`
    )


    emailjs.sendForm("service_3wgxjn7", "template_twn8dix", form.current, "qXhdIC43ULUCQQgWd")
      .then((result) => {
          console.log(result.text);
          console.log("message sent")
      }, (error) => {
          console.log(error.text);
      });


  }
  return (
    <>
      <section className='Contact' id='contact'>
        <div className='container top'>
          <div className='heading text-center'>
            <h4>CONTACT</h4>
            <h1>Contact With Me</h1>
          </div>

          <div className='content d_flex'>
            <div className='left'>
              <div className='box box_shodow'>
                <div className='img'>
                  <img src={contact1} alt='' />
                </div>
                <div className='details'>
                  <h1>Suraj Badwaik</h1>
                  <p>MERN Stack Developer</p>
                  <p></p> <br />
                  <p>Phone: +919146118985</p>
                  <p>Email: surajbadwaik0309@gmail.com</p> <br />
                  <span>FIND WITH ME</span>
                  <div className='button f_flex'>
                    <button className='btn_shadow'>
                      <a href="https://www.facebook.com/suraj.badwaik.52" target="_blank" rel="noreferrer"><RiFacebookBoxLine/></a>
                    </button>
                    <button className='btn_shadow'>
                      <a href="https://www.linkedin.com/in/suraj-badwaik/" target="_blank" rel="noreferrer"><RiLinkedinBoxLine/></a>
                    </button>
                    <button className='btn_shadow'>
                      <a href="https://github.com/Suraj-Badwaik" target="_blank" rel="noreferrer"><RiGithubFill/></a>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className='right box_shodow'>
              <form ref={form} onSubmit={formSubmit}>
                <div className='f_flex'>
                  <div className='input row'>
                    <span>YOUR NAME</span>
                    <input type='text' name='fullname' value={data.fullname} onChange={InputEvent} />
                  </div>
                  <div className='input row'>
                    <span>PHONE NUMBER </span>
                    <input type='number' name='phone' value={data.phone} onChange={InputEvent} />
                  </div>
                </div>
                <div className='input'>
                  <span>EMAIL </span>
                  <input type='email' name='email' value={data.email} onChange={InputEvent} />
                </div>
                <div className='input'>
                  <span>SUBJECT </span>
                  <input type='text' name='subject' value={data.subject} onChange={InputEvent} />
                </div>
                <div className='input'>
                  <span>YOUR MESSAGE </span>
                  <textarea cols='30' rows='10' name='message' value={data.message} onChange={InputEvent}></textarea>
                </div>
                <button className='btn_shadow'>
                  <div className="send_flex">
                  SEND MESSAGE <GrSend/>
                  </div>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Contact
